import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const SharingPlace = withDefaultIconProps({ height: 80, width: 80 }, ({ ...rest }) => (
  <Svg {...rest} viewBox="0 0 80 80" fill="none">
    <G clipPath="url(#clip0_4593_13884)" fill="#2B8176">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.572 66.667c-.28.44-.522.905-.722 1.388l-.16.413a9.004 9.004 0 00-.515 2.588l-.001.055H17.778a4.444 4.444 0 01-4.444-4.444V48.889h4.444v17.778H31.11V48.889h4.445v17.778h15.016z"
      />
      <Path d="M75.089 29.489l-9.067-18.133a4.444 4.444 0 00-3.978-2.467H17.956a4.444 4.444 0 00-3.978 2.467L4.91 29.489a4.445 4.445 0 00-.467 2v6.844a4.444 4.444 0 001.023 2.845 10.378 10.378 0 007.866 3.555A10.49 10.49 0 0020 42.356a10.512 10.512 0 0013.333 0 10.511 10.511 0 0013.334 0 10.511 10.511 0 0013.333 0A10.489 10.489 0 0074.51 41.2a4.444 4.444 0 001.044-2.844v-6.867a4.444 4.444 0 00-.466-2zm-8.422 10.8a5.955 5.955 0 01-4.845-2.511L60 35.288l-1.8 2.49a6.023 6.023 0 01-9.711 0l-1.822-2.49-1.8 2.49a6.024 6.024 0 01-9.711 0l-1.823-2.49-1.8 2.49a6.023 6.023 0 01-9.71 0L20 35.288l-1.822 2.49a5.956 5.956 0 01-4.845 2.51 5.867 5.867 0 01-4.444-1.955V31.49l9.067-18.156h44.088l9.067 18.134v6.8a5.933 5.933 0 01-4.444 2.022zM54 58.5a2 2 0 002 2h13.836l-3.082 3.087a2 2 0 002.831 2.826l5.078-5.085a3.997 3.997 0 001.171-2.828 3.996 3.996 0 00-1.17-2.828l-5.078-5.085a2 2 0 10-2.83 2.826l3.082 3.087H56a2 2 0 00-2 2z" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74 73.5H60.161l3.083 3.087a2 2 0 11-2.83 2.826l-5.078-5.085a3.998 3.998 0 01-.002-5.656l5.078-5.085a2 2 0 012.831 2.826L60.16 69.5H74a2 2 0 110 4z"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_4593_13884">
        <Path fill="#fff" d="M0 0H80V80H0z" />
      </ClipPath>
    </Defs>
  </Svg>
));
